/**
 * all states from store
 */
export default {
  checklists: [],
  show_latter: false,
  breadcrumbs: {
    history: [
      {
        title: 'Home',
        name: 'home',
        path: '/',
        icon: 'home'
      },
    ]
  },
  components_keep_alive: [
    {
      name: 'Home',
      key: 0
    }, 
    {
      name: 'RescueAward',
      key: 0
    },
    {
      name: 'MyWallet',
      key: 0
    },
    {
      name: 'Faq',
      key: 0
    },
    {
      name: 'Extract',
      key: 0
    },
    {
      name: 'Sales',
      key: 0
    },
    {
      name: 'MyLists',
      key: 0
    },
    {
      name: 'MeStore',
      key: 0
    },
    {
      name: 'Missions',
      key: 0
    },
  ]
};
